import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import DiscountGateway from '~apis/discount';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { PayloadAction } from '@reduxjs/toolkit';
import { TCreateDiscountsSettingsReduxParams } from '~types/feat/setting';

export default function* watchCreateDiscountsSettings(api: DiscountGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingCreateDiscountAttempt', handleCreateDiscountsSettings, api);
}

function* handleCreateDiscountsSettings(api: DiscountGateway, data: PayloadAction<TCreateDiscountsSettingsReduxParams>) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const params = data.payload;

    const response = yield* call([api, api.createDiscountsSettings], { authToken, ...params });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingCreateDiscountFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success('Sucessfully created discount!');
        yield put(combinedActions.settingSetProductManagementDiscountCreateModalIsOpen(false));
        yield put(combinedActions.settingCreateDiscountSuccess(response.data));
    }
}
